import { IApplicationState } from '../../types/redux';

export const selectParentRegionId = (state: IApplicationState) => {
  return state.parentRegionId;
};
